import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import FormInputMultiCheckbox from '../../../../../../common/Forms/FormCheckbox';
import FormInputText from '../../../../../../common/Forms/FormTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  setContactKey,
  setHonorific,
  setFirstName,
  setLastName,
  setSuffix,
  setTitle,
  setWorkPhone,
  setParoleOfficer,
  setInactive,
} from '../../../../../../../redux/organization/organizationTabs/addressAndContacts/organizationContacts/organizationContactsSlice';
import {
  ORGANIZATION_ADDRESS_AND_CONTACTS_FORM_UPDATE_URL,
  ORGANIZATION_CONTACTS_FORM_UPDATE_URL,
  paperProps,
} from '../../../../../../../constants';
import {
  postStopApi,
  setStopApi,
} from '../../../../../../../services/StopApi/StopApi';
import { getAddressAndContactsForm } from '../../../../../../../redux/organization/organizationTabs/addressAndContacts/addressAndContactsSlice';
import { organizationContactValidation } from '../../../../../OrganizationUtils/organizationValidation';
import {
  getBackdrop,
  getDialogHeading,
  getFormSuccess,
  getSaveCancel,
} from '../../../../../../common/commonUtils/commonUtils';
import { Form } from '../../../../../../ui/styled';

const OrganizationContactDialog = (props) => {
  const { open, setOpen, openBackdrop, authToken } = props;

  const dispatch = useDispatch();
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewOrganizationContactForm, setIsNewOrganizationContactForm] =
    useState(false);

  const organizationContactForm = useSelector(
    (state) => state.organizationContactForm
  );

  const {
    newOrganizationContactForm,
    _id,
    cntId,
    orgId,
    contactKey,
    honorific,
    firstName,
    lastName,
    suffix,
    title,
    workPhone,
    paroleOfficer,
    inactive,
    addressCity,
    createDate,
    editdate,
    contactEditedby,
    contactCreatedby,
  } = organizationContactForm;

  const fetchData = async () => {
    const commonParams = `${ORGANIZATION_ADDRESS_AND_CONTACTS_FORM_UPDATE_URL}/${orgId}`;
    const authorization = authToken;
    dispatch(getAddressAndContactsForm({ commonParams, authorization }));
  };

  const defaultValue = {
    _id: _id,
    cntId: cntId,
    cntOrgId: orgId,
    contactKey: contactKey,
    honorific: honorific,
    firstName: firstName,
    lastName: lastName,
    suffix: suffix,
    title: title,
    workPhone: workPhone,
    paroleOfficer: paroleOfficer,
    inactive: inactive,
    addressCity: addressCity,
    createDate: createDate,
    editdate: editdate,
    contactEditedby: contactEditedby,
    contactCreatedby: contactCreatedby,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(organizationContactValidation),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue._id,
    defaultValue.cntId,
    defaultValue.cntOrgId,
    defaultValue.contactKey,
    defaultValue.honorific,
    defaultValue.firstName,
    defaultValue.lastName,
    defaultValue.suffix,
    defaultValue.title,
    defaultValue.workPhone,
    defaultValue.paroleOfficer,
    defaultValue.inactive,
    defaultValue.addressCity,
    defaultValue.createDate,
    defaultValue.editdate,
    defaultValue.contactEditedby,
    defaultValue.contactCreatedby,
  ]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${ORGANIZATION_CONTACTS_FORM_UPDATE_URL}`;
    const authorization = authToken;
    const payload = {
      cntId: newOrganizationContactForm ? 0 : cntId,
      cntOrgId: orgId,
      contactKey: contactKey,
      honorific: honorific,
      firstName: firstName,
      lastName: lastName,
      suffix: suffix,
      title: title,
      workPhone: workPhone,
      paroleOfficer: paroleOfficer,
      inactive: inactive,
      addressCity: addressCity,
      createDate: new Date(),
      editdate: new Date(),
      contactEditedby: contactEditedby,
      contactCreatedby: contactCreatedby,
    };
    if (newOrganizationContactForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewOrganizationContactForm(true);
          setOpen(false);
        }
      });
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewOrganizationContactForm(false);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const getOrganizationContactForm = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormInputText
            name='contactKey'
            type='text'
            control={control}
            disabled={true}
            errors={!!errors.contactKey}
            helperText={errors?.contactKey?.message}
            label='Contact Key'
            // register={register('contactKey', {
            //   onChange: (e) => dispatch(setContactKey(e.target.value)),
            // })}
          />
          <FormInputText
            name='honorific'
            type='text'
            control={control}
            errors={!!errors.honorific}
            helperText={errors?.honorific?.message}
            label='Honorific'
            register={register('honorific', {
              onChange: (e) => dispatch(setHonorific(e.target.value)),
            })}
          />
          <FormInputText
            name='firstName'
            type='text'
            control={control}
            errors={!!errors.firstName}
            helperText={errors?.firstName?.message}
            label='First Name'
            register={register('firstName', {
              onChange: (e) => dispatch(setFirstName(e.target.value)),
            })}
          />
          <FormInputText
            name='lastName'
            type='text'
            control={control}
            errors={!!errors.lastName}
            helperText={errors?.lastName?.message}
            label='Last Name'
            register={register('lastName', {
              onChange: (e) => dispatch(setLastName(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormInputText
            name='suffix'
            type='text'
            control={control}
            errors={!!errors.suffix}
            helperText={errors?.suffix?.message}
            label='Suffix'
            register={register('suffix', {
              onChange: (e) => dispatch(setSuffix(e.target.value)),
            })}
          />
          <FormInputText
            name='title'
            type='text'
            control={control}
            errors={!!errors.title}
            helperText={errors?.title?.message}
            label='Title'
            register={register('title', {
              onChange: (e) => dispatch(setTitle(e.target.value)),
            })}
          />
          <FormInputText
            name='workPhone'
            type='text'
            control={control}
            errors={!!errors.workPhone}
            helperText={errors?.workPhone?.message}
            label='Work Phone'
            register={register('workPhone', {
              onChange: (e) => dispatch(setWorkPhone(e.target.value)),
            })}
          />
          <FormInputMultiCheckbox
            name='paroleOfficer'
            label='Parole Officer'
            control={control}
            checked={defaultValue?.paroleOfficer}
            register={register('paroleOfficer', {
              onChange: (e) => dispatch(setParoleOfficer(e.target.value)),
            })}
          />
          <FormInputMultiCheckbox
            name='inactive'
            label='Inactive'
            control={control}
            checked={defaultValue?.inactive}
            register={register('inactive', {
              onChange: (e) => dispatch(setInactive(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={paperProps}>
        {openBackdrop ? (
          getBackdrop(openBackdrop)
        ) : (
          <>
            {getDialogHeading('Contact ID', defaultValue?.cntId, handleClose)}
            <Form>
              {getOrganizationContactForm()}
              {getSaveCancel(handleClose, null, handleSubmit(onSubmit))}
            </Form>
          </>
        )}
      </Dialog>
      {getFormSuccess(
        formSuccess,
        setFormSuccess,
        isNewOrganizationContactForm
      )}
    </>
  );
};

export default OrganizationContactDialog;
